import React from "react";
import styled from "styled-components";
import { colors } from "./colors";

const CardContainer = styled.div`
    background: ${(props) => (props.$isUploading ? colors.neutral[25] : colors.white)} 0% 0% no-repeat padding-box;
    border: 1px solid ${colors.neutral[100]};
    border-radius: 6px;
    opacity: 1;
    padding: 9px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    margin-bottom: 8px;
    -webkit-line-clamp: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const LeftSection = styled.div`
    display: flex;
    align-items: center;
    margin-right: 22px;
    color: ${colors.primary[900]};
`;

const ContentSection = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    max-width: 80%;
    .file-name {
        color: ${colors.neutral[800]};
        font-weight: 500;
        margin-bottom: 4px;
    }

    .file-meta {
        color: ${colors.neutral[500]};
        font-size: 12px;
    }
`;

const RightSection = styled.div`
    display: flex;
    align-items: center;
    margin-left: 12px;
    color: ${colors.neutral[800]};
    cursor: pointer;

    &:hover {
        color: ${colors.danger[900]};
    }
`;

const FileCard = ({ leftIcon, content, rightIcon, isUploading = false }) => {
    return (
        <CardContainer $isUploading={isUploading} data-testid="file-card">
            {leftIcon && <LeftSection>{leftIcon}</LeftSection>}
            {content && <ContentSection>{content}</ContentSection>}
            {rightIcon && <RightSection>{rightIcon}</RightSection>}
        </CardContainer>
    );
};

export default FileCard;
